import { Flex, Text, type FlexProps } from "@mantine/core";
import { IconAlertOctagon } from "@tabler/icons-react";

interface FormErrorBoxProps extends FlexProps {
  message: string;
}

export function FormErrorBox({ message, ...props }: FormErrorBoxProps) {
  return (
    <Flex
      gap="6"
      align="center"
      bg="var(--bg-danger-inverse-default)"
      px="sm"
      py="7"
      bdrs="var(--radius-small)"
      {...props}
    >
      <IconAlertOctagon size={16} color="var(--text-danger-default)" />
      <Text size="xs" c="var(--text-danger)">
        {message}
      </Text>
    </Flex>
  );
}
